import ModalConfirmService from '@/assistente-minutas/services/ModalConfirmService';
import Modal from '@/misc/Modal';
import ConfirmStore from '@/store/ConfirmStore';
import { Recycling } from '@mui/icons-material';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { action, observable, runInAction, makeObservable } from 'mobx';
import React from 'react';
import { Minuta, Processo } from '../modelo';
import { VersaoMinutaDto } from '../modelo/dto/VersaoMinutaDto';
import MinutaService from '../services/MinutaService';

interface IPropsRestaurarVersaoMinuta {
    versao?: VersaoMinutaDto;
    processo?: Partial<Processo>;
    minuta?: Minuta;
    fechar?: any;
}

export default class RestaurarVersaoMinuta extends React.Component<IPropsRestaurarVersaoMinuta> {
    abertoModalRestarurarVersao: boolean = false;

    abrirModalRestarurarVersao = () => {
        this.abertoModalRestarurarVersao = true;
    };

    fecharModalRestarurarVersao = () => {
        this.abertoModalRestarurarVersao = false;
    };

    renderModalRestaurarVersao = () => {
        return (
            <Modal aberto={this.abertoModalRestarurarVersao}
                fecharModal={this.fecharModalRestarurarVersao}
                funcaoAcaoPrimaria={this.restaurarVersaoMinuta}
                labelAcaoPrimaria='Confirmar'
                funcaoAcaoSecundaria={this.fecharModalRestarurarVersao}
                labelAcaoSecundaria='Cancelar'
                titulo={'Confirmação de Restauração'}
                maxWidth='lg' fullWidth
            >
                <Typography>Deseja sobrescrever o conteúdo atual da minuta com o conteúdo desta versão?</Typography>
            </Modal>
        );
    }

    restaurarVersaoMinuta = async () => {

        runInAction(() => {
            ConfirmStore.corpo = `Deseja sobrescrever o conteúdo atual da minuta com o conteúdo desta versão?`;
            ConfirmStore.titulo = 'Alterar o conteúdo da minuta';
        });

        ModalConfirmService.abrirModal();

        if (await ModalConfirmService.aguardarEscolhaDoUsuario()) {
            // if (confirm("Deseja sobrescrever o conteúdo atual da minuta com o conteúdo desta versão?")) {
            await MinutaService.restaurarVersaoMinuta(this.props.versao, this.props.minuta.numero, this.props.processo.numeroProcesso);
            this.props.fechar();
        }
    }

    constructor(props: IPropsRestaurarVersaoMinuta) {
        super(props);

        makeObservable(this, {
            abertoModalRestarurarVersao: observable,
            abrirModalRestarurarVersao: action,
            fecharModalRestarurarVersao: action
        });
    }

    render() {
        return (
            <>
                <Tooltip placement='bottom' title={"Restaurar versão"} >
                    <IconButton id="botaoRestaurarMinuta"
                        onClick={this.restaurarVersaoMinuta}
                        style={{ width: '40px', height: '30px', padding: '0px' }}
                    >
                        <Recycling />
                    </IconButton >
                </Tooltip>
                {this.renderModalRestaurarVersao()}
            </>
        );
    }
}
